/**
 * POST selector payload to admin-ajax (same contract as legacy MVP).
 *
 * @param {object} cfg ignitedProductSelector
 * @param {object[]} selections
 * @param {{ signal?: AbortSignal }} [options]
 * @returns {Promise<object>}
 */
export function fetchProductSelectorScore(cfg, selections, options) {
  const signal = options && options.signal;
  const payload = JSON.stringify({
    // eslint-disable-next-line camelcase
    term_id: cfg.termId,
    selections: selections
  });
  const body = new URLSearchParams();

  body.set("action", cfg.action);
  body.set("nonce", cfg.nonce);
  body.set("payload", payload);
  if (cfg.locale) {
    body.set("locale", cfg.locale);
  }

  return fetch(cfg.ajaxUrl, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    body: body.toString(),
    signal: signal
  })
    .then(function(res) {
      return res.json().then(function(data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    })
    .then(function(result) {
      return result.data;
    });
}
